import { useFloating, autoUpdate, FloatingPortal, offset, useDismiss, useHover, useInteractions } from "@floating-ui/react"
import { ButtonHTMLAttributes, DetailedHTMLProps, HTMLAttributes, useState } from "react"
import { BsCaretDown, BsCaretDownFill, BsCaretUp, BsCaretUpFill } from "react-icons/bs"


type GlassButtonProps = {
   children: React.ReactNode
   title?: string
   "title-placement"?: "top" | "bottom" | "left" | "right"
} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>

export function OnMapButton({ title, ...props }: GlassButtonProps) {
   const [tooltipOpen, setTooltipOpen] = useState(false);
   const { refs, floatingStyles, context: tooltipContext } = useFloating({
      whileElementsMounted: autoUpdate,
      placement: props["title-placement"] || "bottom",
      open: tooltipOpen,
      middleware: [offset(5)],
      onOpenChange: setTooltipOpen,
   });

   const {
      getFloatingProps: getTooltipFloatingProps
   } = useInteractions([useHover(tooltipContext), useDismiss(tooltipContext)]);


   return (
      <>
         <button {...props} ref={refs.setReference} type="button" className={"OnMapButton " + (props.className || "")} >
            {props.children}
         </button>
         {Boolean(title && tooltipOpen) &&
            <FloatingPortal>
               <div ref={refs.setFloating} className="OnMapButtonToolTip" style={floatingStyles} {...getTooltipFloatingProps()} >
                  {title || "ThisIsToolTIp"}
               </div>
            </FloatingPortal>
         }
      </>
   )
}

export function GlassButton({ title, ...props }: GlassButtonProps) {
   const [tooltipOpen, setTooltipOpen] = useState(false);
   const { refs, floatingStyles, context: tooltipContext } = useFloating({
      whileElementsMounted: autoUpdate,
      placement: props["title-placement"],
      open: tooltipOpen,
      middleware: [offset(5)],
      onOpenChange: setTooltipOpen,
   });

   const {
      getFloatingProps: getTooltipFloatingProps
   } = useInteractions([useHover(tooltipContext), useDismiss(tooltipContext)]);


   return (
      <>
         <button {...props} ref={refs.setReference} type="button" className={"GlassButton " + (props.className || "")} >
            {props.children}
         </button>
         {Boolean(title && tooltipOpen) &&
            <FloatingPortal>
               <div ref={refs.setFloating} className="GlassButtonToolTip" style={floatingStyles} {...getTooltipFloatingProps()} >
                  {title || "ThisIsToolTIp"}
               </div>
            </FloatingPortal>
         }
      </>
   )
}

type GlassButtonDivProps = {
   children: React.ReactNode
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export function GlassInfoButton(props: GlassButtonDivProps) {
   return (
      <div {...props} className={"GlassDivButton " + (props.className || "")}>
         {props.children}
      </div>
   )
}

export function GlassButtonRow(props: { children, wrap?, adjust?: "start" | "center" | "end" }) {
   return (
      <div className="GlassButtonRow" style={{ flexWrap: (props.wrap ? "wrap" : "nowrap"), justifyContent: props.adjust || "start" }}>
         {props.children}
      </div>
   )
}


export function GlassButtonDropdown({ children, options, onSelect, ...props }: GlassButtonProps & { options: { text: string, value: any }[], onSelect: (a) => void, placement?: "bottom-start" | "bottom-end" | "top-start" | "top-end" }) {
   const [showOptions, setShowOptions] = useState<boolean>(false)
   const { refs, floatingStyles } = useFloating({
      whileElementsMounted: autoUpdate,
      placement: props.placement || "bottom-end",
   });

   return (
      <>
         <button className={"GlassButton " + props.className} ref={refs.setReference} onClick={() => setShowOptions((a) => !a)}>
            {children}
            <div className="ViewButton-Carret">
               {props.placement?.split?.("-")[0] === "top" ?
                  !showOptions ? <BsCaretUp /> : <BsCaretUpFill /> :
                  !showOptions ? <BsCaretDown /> : <BsCaretDownFill />
               }
            </div>
         </button>
         {
            showOptions ? (
               <FloatingPortal  >
                  <div ref={refs.setFloating} className="ViewButtonDropDown" style={{ zIndex: "1001", ...floatingStyles }} >
                     {options.map((a) => {
                        return (
                           <button key={a.value} onClick={() => { onSelect(a.value); setShowOptions(false) }}>{a.text}</button>
                        )
                     })}
                  </div>
               </FloatingPortal>
            ) : null}
      </>
   )
}
